export default {
    data() {
        return {
            resizeEvent: null,
            scrollEvent: null,
        }
    },
    mounted() {
        this.tableScrollInit()
    },
    destroyed() {
        window.removeEventListener('resize', this.resizeEvent);
        document.getElementById('fixed-table').removeEventListener('scroll', this.scrollEvent)
    },
    methods: {
        tableScrollInit() {
            //1.根据内容的大小，计算滚动条的高度
            const my$ = (id) => {
                return document.getElementById(id);
            }
            var box = my$('content-table-box');
            var box_top = my$('content-table-top');
            var table_thead_top = my$('table-thead-top');
            var box_bottom = my$('scroll');
            var mask = my$('bar');
            var fixedLeft = my$('fixed-left');
            var fixedRight = my$('fixed-right');
            //          滚动条的长度 = (盒子的宽度 / 内容的宽度)*盒子的宽度
            var mask_len = (box.offsetWidth / box_top.offsetWidth) * box.offsetWidth
            let scrollLength = 0

            mask.style.width = mask_len + "px"
            box_bottom.style.left = (fixedLeft.offsetWidth + 16) + "px"
            this.$nextTick(() => {
                box_bottom.style.width = (box.offsetWidth) + 'px';
            })

            // let scrolledShadow = document.querySelectorAll('.scrolled-shadow');

            let scrolledInShadow = document.querySelectorAll('.scrolled-in-shadow');
            let scrolledOutShadow = document.querySelectorAll('.scrolled-out-shadow');

            if (scrollLength <= 0) {
                for (let i = 0; i < scrolledOutShadow.length; i++) {
                    scrolledOutShadow[i].classList.add('scrolled-shadow-show');
                }
            }

            setTimeout(() => {
                mask_len = (box.offsetWidth / box_top.offsetWidth) * box.offsetWidth
                if (mask_len + 14 >= box.offsetWidth) {
                    for (let i = 0; i < scrolledInShadow.length; i++) {
                        scrolledInShadow[i].classList.remove('scrolled-shadow-show');
                    }
                    for (let i = 0; i < scrolledOutShadow.length; i++) {
                        scrolledOutShadow[i].classList.remove('scrolled-shadow-show');
                    }
                }
            }, 300)

            document.getElementById('table-wrapper').onmouseenter = function (e) {
                e.preventDefault();
                e.stopPropagation()
                box_bottom.style.width = (box.offsetWidth) + 'px';
                mask_len = (box.offsetWidth / box_top.offsetWidth) * box.offsetWidth

                mask.style.width = mask_len + "px"

                if (mask_len + 14 < box.offsetWidth) {
                    box_bottom.classList.add('scroll-slide-show');

                    // for (let i = 0; i < scrolledShadow.length; i++) {
                    //     scrolledShadow[i].classList.add('scrolled-shadow-show');
                    // }
                }
            }
            document.getElementById('table-wrapper').onmouseleave = function (e) {
                e.preventDefault();
                e.stopPropagation()
                box_bottom.classList.remove('scroll-slide-show')

                // for (let i = 0; i < scrolledShadow.length; i++) {
                //     scrolledShadow[i].classList.remove('scrolled-shadow-show');
                // }
                document.onmousemove = null;
            }

            //2.让滚动条能够拖拽
            //2.1 当鼠标按下的时候，求鼠标在滚动条中的位置
            mask.onmousedown = function (e) {
                e = e || window.event;
                var beginX = e.clientX - mask.offsetLeft
                //鼠标在滚动条中的位置
                //2.2鼠标在页面上移动的时候，滚动条的位置
                document.onmousemove = function (e) {
                    e.preventDefault()
                    e = e || event
                    var endX = e.clientX - beginX;
                    if (endX < 0) {
                        endX = 0
                    }
                    if (endX >= box.offsetWidth - mask.offsetWidth) {
                        endX = box.offsetWidth - mask.offsetWidth
                    }
                    scrollLength = endX;


                    let scrolledInShadow = document.querySelectorAll('.scrolled-in-shadow');
                    let scrolledOutShadow = document.querySelectorAll('.scrolled-out-shadow');
                    if (scrollLength <= 0) {
                        for (let i = 0; i < scrolledOutShadow.length; i++) {
                            scrolledOutShadow[i].classList.add('scrolled-shadow-show');
                        }
                        for (let i = 0; i < scrolledInShadow.length; i++) {
                            scrolledInShadow[i].classList.remove('scrolled-shadow-show');
                        }
                    } else if (scrollLength >= box.offsetWidth - mask.offsetWidth) {
                        for (let i = 0; i < scrolledInShadow.length; i++) {
                            scrolledInShadow[i].classList.add('scrolled-shadow-show');
                        }
                        for (let i = 0; i < scrolledOutShadow.length; i++) {
                            scrolledOutShadow[i].classList.remove('scrolled-shadow-show');
                        }
                    } else {
                        for (let i = 0; i < scrolledOutShadow.length; i++) {
                            scrolledOutShadow[i].classList.add('scrolled-shadow-show');
                        }
                        for (let i = 0; i < scrolledInShadow.length; i++) {
                            scrolledInShadow[i].classList.add('scrolled-shadow-show');
                        }
                    }

                    mask.style.left = endX + "px"
                    //内容走的距离 = （内容的长度 - 盒子的长度 ）/ （盒子的长度 - 滚动条的长度）*滚动条走的距离
                    var contentL = (box_top.offsetWidth - box.offsetWidth) / (box.offsetWidth - mask.offsetWidth) * endX;
                    box_top.style.left = -(contentL) + "px"
                    table_thead_top.style.left = -(contentL) + "px";

                    document.getElementsByClassName('flexarea')[0].getElementsByTagName('table')[0].style.left = -contentL + "px"
                    document.getElementsByClassName('flexarea')[1].getElementsByTagName('table')[0].style.left = -contentL + "px"
                    window.getSelection ? window.getSelection().removeAllRanges() : document.selection.empty()//防止拖动时选中内容  
                }
                document.onmouseup = function (e) {
                    e = e || event
                    //移除鼠标移动事件
                    document.onmousemove = null;
                }
            }



            let init = () => {
                box_bottom.style.width = box.offsetWidth + 'px';
                mask_len = (box.offsetWidth / box_top.offsetWidth) * box.offsetWidth;
                mask.style.width = mask_len + "px"
                mask.style.left = 0;
                box_top.style.left = 0;
                table_thead_top.style.left = 0;

                for (let i = 0; i < scrolledInShadow.length; i++) {
                    scrolledInShadow[i].classList.remove('scrolled-shadow-show');
                }
                for (let i = 0; i < scrolledOutShadow.length; i++) {
                    scrolledOutShadow[i].classList.add('scrolled-shadow-show');
                }

                setTimeout(() => {

                    if (mask_len + 14 >= box.offsetWidth) {
                        for (let i = 0; i < scrolledInShadow.length; i++) {
                            scrolledInShadow[i].classList.remove('scrolled-shadow-show');
                        }
                        for (let i = 0; i < scrolledOutShadow.length; i++) {
                            scrolledOutShadow[i].classList.remove('scrolled-shadow-show');
                        }
                    }
                }, 300)


            }
            init()
            this.resizeEvent = (resizeEvent) => {
                resizeEvent = resizeEvent || event;
                init();
            }

            this.scrollEvent = (scrollEvent) => {
                let scrollLeft = scrollEvent.target.scrollLeft;

                if (scrollLeft >= 0) {
                    box_bottom.style.left = (fixedLeft.offsetWidth + 16 - scrollLeft) + "px"
                }
            }

            window.addEventListener('resize', this.resizeEvent);


            document.getElementById('fixed-table').addEventListener('scroll', this.scrollEvent)
        }
    },
}